export const environment = {
  production: true,
  baseBE: '/api/',
  basePaymentBE: '/payment_api/v1/'
};
